<p-toast></p-toast>
<div class="grid">
    <div class="col-12">
        <div class="card">
			<h5>Gestion de Cartera</h5>
            <hr>
            <form *ngIf="formGroup" [formGroup]="formGroup" (ngSubmit)="ejecutar()">
                <div class="p-fluid p-formgrid grid">
                    <div class="field col-12 md:col-2">
                        <label htmlFor="fecha_desde">Fecha Desde</label>
                        <p-calendar id="fecha_desde" formControlName="fecha_desde" dateFormat="dd/mm/yy"></p-calendar>
                    </div>
                    <div class="field col-12 md:col-2">
                        <label htmlFor="fecha_hasta">Fecha Hasta</label>
                        <p-calendar id="fecha_hasta" formControlName="fecha_hasta" dateFormat="dd/mm/yy"></p-calendar>
                    </div>
                </div>
                <div class="grid">
                    <div class="col-12 md:col-2">
                        <button pButton pRipple type="submit" label="Ejecutar" icon="pi pi-check" class="p-button-info mr-2" pTooltip="Ejecutar"></button>
                    </div>
                    <ng-container *ngIf="items?.length">
                        <div class="col-12 md:col-2">
                            <button pButton pRipple class="p-button-warning" label="Imprimir" icon="pi pi-print" (click)="descargar()"></button>
                        </div>
                        <div class="col-12 md:col-2">
                            <button pButton pRipple class="p-button-success" label="Descargar" icon="pi pi-file-excel" (click)="descargarExcel()"></button>
                        </div>
                        <div class="col-12 md:col-2">
                            <button pButton pRipple type="button" label="Generar Archivo" icon="pi pi-file" class="p-button-info mr-2" pTooltip="Generar Archivo" (click)="generarArchivo()"></button>
                        </div>
                    </ng-container>
                </div>
            </form>
            <p-table styleClass="p-datatable-sm p-datatable-gridlines" [value]="items" [loading]="loading" dataKey="nro_transaccion" responsiveLayout="scroll" rowHover="true"  [showCurrentPageReport]="true" 
            [paginator]="true" [rows]="20" currentPageReportTemplate="Mostrando {first} a {last} de {{items.length}} entradas">
                <ng-template pTemplate="header">
                    <tr>
                        <!-- <th class="cabecera align-center" pSortableColumn="fecha_transaccion">Fecha<p-sortIcon field="fecha_transaccion"> </p-sortIcon></th> -->
                        <th class="cabecera align-center" pSortableColumn="nombre_entidad">Entidad<p-sortIcon field="nombre_entidad"></p-sortIcon></th>
                        <th class="cabecera align-center" pSortableColumn="asignado">Asignados<p-sortIcon field="asignado"></p-sortIcon></th>
                        <th class="cabecera align-center" pSortableColumn="gestionado">Gestionados<p-sortIcon field="gestionado"></p-sortIcon></th>
                        <th class="cabecera align-center" pSortableColumn="promesas_pago">Promesas de Pago<p-sortIcon field="promesas_pago"></p-sortIcon></th>
                        <th class="cabecera align-center" pSortableColumn="no_contactados">No Contactados<p-sortIcon field="no_contactados"></p-sortIcon></th>
                        <th class="cabecera align-center" pSortableColumn="reagendados">Reagendados<p-sortIcon field="reagendados"></p-sortIcon></th>
                        <th class="cabecera align-center" pSortableColumn="cantidad_cobrada">Cantidad Cobrada<p-sortIcon field="cantidad_cobrada"></p-sortIcon></th>
                        <th class="cabecera align-center" pSortableColumn="importe_cobrado">Importe Cobrado<p-sortIcon field="importe_cobrado"></p-sortIcon></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item >
                    <tr>
                        <td>{{ item.fecha_transaccion | date: 'dd/MM/yyyy' }}</td>
                        <td>{{ item.nombre_entidad }}</td>
                        <td class="align-monto">{{ item.asignado | currency: '':'':'0.0':'es-PY'}}</td>
                        <td class="align-monto">{{ item.gestionado | currency: '':'':'0.0':'es-PY'}}</td>
                        <td class="align-monto">{{ item.promesas_pago | currency: '':'':'0.0':'es-PY'}}</td>
                        <td class="align-monto">{{ item.no_contactado | currency: '':'':'0.0':'es-PY'}}</td>
                        <td class="align-monto">{{ item.reagendado | currency: '':'':'0.0':'es-PY'}}</td>
                        <td class="align-monto">{{ item.cantidad_cobrada | currency: '':'':'0.0':'es-PY'}}</td>
                        <td class="align-monto">{{ item.importe_cobrado | currency: '':'':'0.0':'es-PY'}}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="footer">
                    <tr>
                        <td class="cabecera-detalle">TOTALES</td>
                        <td class="cabecera-detalle align-monto"><b>{{ totalAsignado | currency: '':'':'0.0':'es-PY' }}</b></td>
                        <td class="cabecera-detalle align-monto"><b>{{ totalGestionado | currency: '':'':'0.0':'es-PY' }}</b></td>
                        <td class="cabecera-detalle align-monto"><b>{{ totalPromesa | currency: '':'':'0.0':'es-PY' }}</b></td>
                        <td class="cabecera-detalle align-monto"><b>{{ totalNoContactado | currency: '':'':'0.0':'es-PY' }}</b></td>
                        <td class="cabecera-detalle align-monto"><b>{{ totalReagendado | currency: '':'':'0.0':'es-PY' }}</b></td>
                        <td class="cabecera-detalle align-monto"><b>{{ totalCantidadCobrada | currency: '':'':'0.0':'es-PY' }}</b></td>
                        <td class="cabecera-detalle align-monto"><b>{{ totalImporteCobrado | currency: '':'':'0.0':'es-PY' }}</b></td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>

<app-on-lista [show]="showOnLista" [title]="tituloOnLista" [columns]="columnasOnLista" [service]="serviceOnLista" [recordName]="recordNameOnLista"
    (close)="cerrarOnLista($event)">
</app-on-lista>